import React from 'react';

import classNames from 'classnames';
import styles from './spinner.less';

interface SpinnerProps {
  inline?: boolean;
  centered?: boolean;
  small?: boolean;
  modLeft?: boolean;
  text?: string;
  wrapperClassName?: string;
}

const Spinner: React.FunctionComponent<SpinnerProps> = ({
  inline,
  centered,
  small,
  modLeft,
  text,
  wrapperClassName,
}) => {
  const wrapperClasses = {
    [styles.inline]: !!inline,
    [styles.centered]: !!centered,
  };
  const iconClasses = {
    [styles.small]: !!small,
    [styles.modLeft]: !!modLeft,
  };

  return (
    <div
      className={classNames(styles.wrapper, wrapperClasses, wrapperClassName)}
    >
      <span className={classNames(styles.spinner, iconClasses)} />
      {text}
    </div>
  );
};

export default Spinner;



// WEBPACK FOOTER //
// ./app/common/components/loading/spinner.tsx